import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, DEFAULT_SUBLINE_ITEM_CHARGE_TYPE } from '../../../constants/external-constants';
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';

import { 
    setDefaultSubLineItem, 
    getAllSubLine, 
    setAllSubLineError, 
    setAllSubLineItemPageSize,
    sortAllSubLineItems,
    setAllSubLineItemColSearchStr,
    getSubLineGrossSummary } from '../../../constants/model-reducers/external/invoice/subline-item.settings'

const defaultState = () => ({
    isAllSubLineItemLoaded: false,
    isAllSubLineItemError: false,
    allSubLineItems: DEFAULT_TABLE_RESULT_MODEL,
    allSubLineItemColSort: '',
    allSubLineItemIsSortedAsc: false,
    allSubLineItemFilterList: [],
    subLineGrossSummary: DEFAULT_SUBLINE_ITEM_CHARGE_TYPE.barChart,
    isSublineGrossSummaryLoaded: false,
    isSublineGrossSummaryError: false
});

const initialState = defaultState();

export const invoiceSubLineActions = {
    setDefaultSubLineItem: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultSubLineItem,
            subLineItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getAllSubLineItems: (selectedItem, pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().invoiceSubLine.allSubLineItems;
        const { allSubLineItemColSort, allSubLineItemIsSortedAsc, allSubLineItemFilterList } = state().invoiceSubLine;

        var userId = sessionStorage.getItem('UserID');

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: allSubLineItemColSort,
                IsSortAscending: allSubLineItemIsSortedAsc,
                TableFilterList: allSubLineItemFilterList,
                LineItemID: selectedItem.LineItemID
            };

            var allSubLineItems = await httpPost('external/subLine/getSubLineItems', data);

            dispatch({
                type: getAllSubLine,
                allSubLineItems: Object.keys(allSubLineItems).length > 0 ? allSubLineItems : DEFAULT_TABLE_RESULT_MODEL,
                isAllSubLineItemLoaded: true,
                isAllSubLineItemError: false
            });
        }

        catch (e) {
            dispatch({
                type: setAllSubLineError,
                isAllSubLineItemLoaded: true,
                isAllSubLineItemError: false
            });
        }
    },
    resizeAllSubLineItemPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setAllSubLineItemPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    sortAllSubLineItems: (columnClicked, isSortedAsc, selectedItem) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().invoiceSubLine.allSubLineItems.Pagination;
        const { allSubLineItems, allSubLineItemFilterList } = state().invoiceSubLine;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: allSubLineItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...allSubLineItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: allSubLineItemFilterList,
            LineItemID: selectedItem.LineItemID
        };
        var resAllSubLineItems = await httpPost('external/subLine/getSubLineItems', data);
        if (resAllSubLineItems.ok === false) {
            dispatch({
                type: setAllSubLineError,
                isAllSubLineItemLoaded: true,
                isAllSubLineItemError: false
            });
        } else {
            dispatch({
                type: sortAllSubLineItems,
                allSubLineItems: Object.keys(resAllSubLineItems).length > 0 ? resAllSubLineItems : DEFAULT_TABLE_RESULT_MODEL,
                allSubLineItemColSort: columnClicked,
                allSubLineItemIsSortedAsc: isSortedAsc,
                isAllSubLineItemLoaded: true
            });
        }
    },
    setAllSubLineItemColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { allSubLineItems } = state().invoiceSubLine;
        var allSubLineItemsUpd = {
            ...allSubLineItems,
            "Headers": {
                ...allSubLineItems.Headers,
                [key]: {

                    ...allSubLineItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setAllSubLineItemColSearchStr,
            data: allSubLineItemsUpd,
            isAllSubLineItemError: false,
            isAllSubLineItemLoaded: true
        });
    },
    getSubLineGrossSummary: (selectedItem) => async (dispatch, state) => {


        try {
            var data = {
                LineItemID: selectedItem.LineItemID

            };

            var subLineGrossSummary = await httpPost('external/subLine/getSubLineItemGrossSummary', data);

            dispatch({
                type: getSubLineGrossSummary,
                subLineGrossSummary: Object.keys(subLineGrossSummary).length > 0 ? subLineGrossSummary : [],
                isSublineGrossSummaryLoaded: true,
                isSublineGrossSummaryError: false
            });
        }

        catch (e) {
            dispatch({
                type: getSubLineGrossSummary,
                isSublineGrossSummaryLoaded: true,
                isSublineGrossSummaryError: false
            });
        }
    },
    extractAllSublineItems: (selectedItem, invoiceNumber, billedCircuitId) => async (dispatch, state) => {
        const { Headers } = state().invoiceSubLine.allSubLineItems;
        const { activeDateFormat } = state().adminSetting;
        const dealName = sessionStorage.getItem('DealName');

        var filename = `ATEM ${dealName} Invoice SubLine Item - ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;

        var data = {
            InvoiceNumber: invoiceNumber,
            BilledCircuitID: billedCircuitId,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            LineItemID: selectedItem.LineItemID,
            FileName: filename,
        };

        httpDownload('external/subLine/getAllExtractSublineItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getAllSubLine:
            return {
                ...state,
                allSubLineItems: action.allSubLineItems,
                isAllSubLineItemLoaded: action.isAllSubLineItemLoaded,
                isAllSubLineItemError: action.isAllSubLineItemError
            };
        case setAllSubLineError:
            return {
                ...state,
                isAllSubLineItemError: action.isAllSubLineItemError,
                isAllSubLineItemLoaded: action.isAllSubLineItemLoaded
            };
        case setAllSubLineItemPageSize:
            return {
                ...state,
                allSubLineItems: {
                    ...state.allSubLineItems,
                    Pagination: {
                        ...state.allSubLineItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case sortAllSubLineItems:
            return {
                ...state,
                allSubLineItems: action.allSubLineItems,
                allSubLineItemColSort: action.allSubLineItemColSort,
                allSubLineItemIsSortedAsc: action.allSubLineItemIsSortedAsc,
                isAllSubLineItemLoaded: action.isAllSubLineItemLoaded
            };
        case setAllSubLineItemColSearchStr:
            return {
                ...state,
                allSubLineItems: action.data,
                isAllSubLineItemLoaded: action.isAllSubLineItemLoaded,
                isAllSubLineItemError: action.isAllSubLineItemError
            }
        case getSubLineGrossSummary:
            return {
                ...state,
                subLineGrossSummary: action.subLineGrossSummary,
                isSublineGrossSummaryLoaded: action.isSublineGrossSummaryLoaded,
                isSublineGrossSummaryError: action.isSublineGrossSummaryError
            };
        case setDefaultSubLineItem:
            return initialState;
        default:
            return state;
    }
};